import { render, staticRenderFns } from "./SidebarStyle.vue?vue&type=template&id=53d59ad2&scoped=true&"
import script from "./SidebarStyle.vue?vue&type=script&lang=js&"
export * from "./SidebarStyle.vue?vue&type=script&lang=js&"
import style0 from "./SidebarStyle.vue?vue&type=style&index=0&id=53d59ad2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d59ad2",
  null
  
)

export default component.exports